import { GetVendorParams } from "./vendor.types";

export const VENDOR_KEYS = {
  VENDORS: "VENDORS",
  GET_VENDORS: (params?: GetVendorParams) => [VENDOR_KEYS.VENDORS, params],
  GET_VENDOR: (taskId?: string) => [VENDOR_KEYS.VENDORS, taskId],
};
